@if (level) {
  <div>
    @if (chartDatasets) {
      <highcharts-chart
        class="w-100 d-block"
        [Highcharts]="highcharts"
        [options]="chartOptions"
        [callbackFunction]="chartCallback">
      </highcharts-chart>
    }
  </div>
}
